export const GOOGLE_MAPS_LIBRARIES: ("places" | "drawing" | "geometry")[] = [
  "places",
];

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "",
  libraries: GOOGLE_MAPS_LIBRARIES,
} as const;
